import request from '@/utils/request'

const url = '/home/resources/'
const api = {
  Query (data) {
    return request({
      url: url + 'Query',
      method: 'post',
      data
    })
  },
  getIndustryInfo (data) {
    return request({
      url: url + 'getIndustryInfo',
      method: 'post',
      data
    })
  },
  getProductKnow (data) {
    return request({
      url: url + 'getProductKnow',
      method: 'post',
      data
    })
  },
  getDetail (data) {
    return request({
      url: url + 'getDetail',
      method: 'post',
      data
    })
  },
  getClassifyThemeLabel (data) {
    return request({
      url: url + 'getClassifyThemeLabel',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/resources.js